<div class="main no-padding">
    <header-menu></header-menu>
    <div class="colab-manager-wrapper">
      <div class="col-sm-2 no-padding colab-manager-menu">
          <ul>
            <li [ngClass]="{'active': activatedRoute === '/campanhas/lista/(campanhas:especiais)' || activatedRoute === '/campanhas/lista' || !activatedRoute}"><a [routerLink]="['/campanhas/lista',{outlets:{campanhas:'especiais'}}]" title="{{ 'COMPANY.CAMPAIGN.MENU.SPECIAL' | translate }}"><i class="fa fa-file-o" aria-hidden="true"></i> {{ 'COMPANY.CAMPAIGN.MENU.SPECIAL' | translate }}</a></li>
            <li [ngClass]="{'active': activatedRoute === '/campanhas/lista/(campanhas:basicas)' }"><a [routerLink]="['/campanhas/lista',{outlets:{campanhas:'basicas'}}]" title="{{ 'COMPANY.CAMPAIGN.MENU.BASIC' | translate }}"><i class="fa fa-copy" aria-hidden="true"></i> {{ 'COMPANY.CAMPAIGN.MENU.BASIC' | translate }}</a></li>
            <li [ngClass]="{'active': activatedRoute === '/campanhas/lista/(campanhas:envio-direto)'}"><a [routerLink]="['/campanhas/lista',{outlets:{campanhas:'envio-direto'}}]" title="{{ 'COMPANY.CAMPAIGN.MENU.DIRECT' | translate }}"><i class="fa fa-paper-plane-o" aria-hidden="true"></i> {{ 'COMPANY.CAMPAIGN.MENU.DIRECT' | translate }}</a></li>
          </ul>
      </div>

      <div class="col-sm-10 colab-manager-content no-padding">
          <router-outlet name="campanhas"></router-outlet>
      </div>
      <div class="clearfix"></div>
    </div>

  </div>
